import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { FeatureToggleActions } from "./model";

export const FeatureToggleController = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(FeatureToggleActions.getFeatureToggles());
  }, [dispatch]);
};
